// The attachment cloud mirror must never outlive an unsent message, so it
// does not start inside the preparation: this gate resolves the moment
// thread.turn.start is accepted and rejects the moment the turn is known not
// to start (abort, dispatch failure), and the preparation mirrors only on the
// resolve path. Extracted from dispatchChatTurnStart so the dispatch
// orchestration stays under the file-size cap (forge#3516).
export type CloudMirrorGate = {
  accepted: Promise<void>;
  accept: () => void;
  cancel: (reason: unknown) => void;
};

const gateNoop = () => undefined;

export function createCloudMirrorGate(): CloudMirrorGate {
  let accept: () => void = gateNoop;
  let cancel: (reason: unknown) => void = gateNoop;
  const accepted = new Promise<void>((resolve, reject) => {
    accept = resolve;
    cancel = reject;
  });
  // Keep the original gate rejectable for mirror subscribers, even if none attach.
  void accepted.catch(gateNoop);
  return { accepted, accept, cancel };
}
